// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const GoTo = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M8 5h5v1H8z" />
    <path fill="currentColor" d="M12 10V5h1v5z" />
    <path stroke="currentColor" d="m12.5 5.5-8 8" />
  </svg>
);
const ForwardRef = forwardRef(GoTo);
export default ForwardRef;
